<template>
  <div class="desktop-filters-container">
    <v-expansion-panels
      class="desktop-menu-filters"
      multiple
      flat
      v-model="panel"
    >
      <v-expansion-panel v-for="facet in facetsFiltered" :key="facet.name">
        <v-expansion-panel-header class="panel-header">
          <b>{{ facet.name }}</b>
          <span
            class="grey--text caption"
            v-if="
              facetsFilter[facet.parameterName] &&
                facetsFilter[facet.parameterName].length > 0
            "
          >
            (+{{ facetsFilter[facet.parameterName].length }} filtri)
          </span>
          <!-- <template v-slot:actions>
            <v-tooltip
              left
              v-if="
                facetsFilter[facet.parameterName] &&
                  facetsFilter[facet.parameterName].length > 0
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click.prevent.stop="clearFacets(facet.parameterName)"
                >
                  <v-icon style="font-style:normal" small>x</v-icon>
                </v-btn>
              </template>
              Rimuovi i filtri per {{ facet.name }}
            </v-tooltip>
          </template> -->
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <filtered-chebox-list
            :facet="facet"
            :facetsFilter="facetsFilter"
            @handleFacetFilterMobile="handleFacetFilterMobile"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<style global lang="scss">
@import "@/scss/variables.scss";
.panel-header {
  background-color: var(--v-grey-lighten2);
  padding: 0;
  text-transform: uppercase;
  min-height: 32px !important;
  font-size: 13px;
  border-top: 1px solid var(--v-grey-lighten1);
  .v-expansion-panel-header__icon {
    i {
      color: $primary !important;
    }
  }
}
.panel-content {
  background-color: var(--v-grey-lighten2);
  .v-expansion-panel-content__wrap {
    padding: 0;
  }
  .panel-checkbox {
    margin-top: 0;
    .v-label {
      font-size: 13px !important;
    }
  }
}
.filters-container {
  height: calc(100vh - 52px);
  overflow-y: auto;
  .v-expansion-panel-content__wrap {
    background-color: transparent;
  }
  .row {
    .col {
      padding: 10px;
    }
  }
  .v-expansion-panel {
    border-bottom: 1px solid var(--v-grey-lighten2);
  }
}

.filters-container-upper-row {
  height: 50px;
}

.filters-container-buttons {
  border-top: 1px solid var(--v-grey-lighten2);
  // height: 85px;
  .filter-button {
    width: 46%;
    font-size: 0.75rem;
    @media (max-width: 360px) {
      font-size: 0.65rem;
    }
  }
}
</style>
<script>
import FilteredCheboxList from "./FilteredCheboxList.vue";

export default {
  components: { FilteredCheboxList },
  name: "ProductFacetFilterMobile",
  data() {
    return {
      dialog: false,
      panel: [0, 1, 2, 3],
      panelLength: [6, 6, 6, 6],
      loadingApplyButton: false,
      initialFacets: {}
    };
  },
  props: {
    facets: { type: Array },
    facetsFilter: { type: Object },
    filteredProductsCount: { type: Number, required: false },
    hideFilterString: { type: String, default: "" },
    hidePreferredFilter: { type: Boolean, default: false }
  },
  computed: {
    facetsFiltered() {
      let vm = this;
      if (vm.facets) {
        return vm.facets.filter(
          item => vm.hideFilterString.indexOf(item.name) < 0
        );
      } else {
        return {};
      }
    }
  },
  methods: {
    handleFacetFilterMobile(param) {
      this.$emit("handleFacetFilterMobile", param);
      this.loadingApplyButton = true;
    }
  }
};
</script>

<style></style>
